var map = {
	"./profile_box_coach_licenses.svg": "404a",
	"./profile_box_coach_place_name.svg": "cd79",
	"./profile_box_coach_position.svg": "2c05",
	"./profile_box_coach_star.svg": "f470",
	"./profile_box_coach_type.svg": "ac85",
	"./profile_box_coach_use_reasons.svg": "1751"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1a87";